import {
  Box,
  Paper,
  Skeleton,
  Stack,
  SxProps,
  Typography,
  alpha
} from '@mui/material'

import { FC } from 'react'
import {
  MapLegendColorRamps,
  MapLegendColorRampsProps
} from './MapLegendColorRamps'

export type MapLegendProps = MapLegendColorRampsProps & {
  sx?: SxProps
  title: string
}

export const MapLegend: FC<MapLegendProps> = (props) => {
  const { sx, title, jenks, ramps, visualisationType, ...rest } = props

  return (
    <Box
      component={Paper}
      variant='outlined'
      sx={[
        (theme) => ({
          display: 'flex',
          flexDirection: 'column',
          p: 2,
          position: 'relative',
          borderRadius: 2,
          backgroundColor: alpha(theme.palette.background.paper, 1),
          [theme.breakpoints.down('mobile')]: {
            p: 1
          }
        }),
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
      {...rest}
    >
      <MapVisualisationTitle
        title={title}
        loading={false}
      />

      <MapLegendColorRamps
        jenks={jenks}
        ramps={ramps}
        visualisationType={visualisationType}
      />
    </Box>
  )
}

const PrimaryText = ({ text }) => {
  return (
    <Box
      component={Typography}
      sx={{
        fontSize: '1.25rem',
        fontWeight: 'bold',
        letterSpacing: 'tighter'
      }}
    >
      {text}
    </Box>
  )
}

const MapVisualisationTitle = ({ title, loading }) => {
  if (loading) {
    return (
      <Stack
        direction='column'
        gap={1}
      >
        <Box
          component={Skeleton}
          animation={false}
          width='300px'
          height='30px'
          variant='rounded'
        />
      </Stack>
    )
  }

  return (
    <Stack
      direction='row'
      gap={2}
      alignItems='center'
      flexWrap='wrap'
    >
      <PrimaryText text={title} />
    </Stack>
  )
}
